import { render, staticRenderFns } from "./tna-period.vue?vue&type=template&id=4fddf811&scoped=true"
import script from "./tna-period.vue?vue&type=script&lang=js"
export * from "./tna-period.vue?vue&type=script&lang=js"
import style0 from "./tna-period.vue?vue&type=style&index=0&id=4fddf811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fddf811",
  null
  
)

export default component.exports